import { GemmaError } from "@gemma/errors";
import { IFilter } from "../../QueryOptions";
import { IResolvedPermissions } from "../IResolvedPermissions";
import { IRowMeta } from "../Row/mixins/IRowMeta";
import { ISummaryRowEntity } from "../Row/mixins/ISummaryRowEntity";
import { ISummaryVue } from "../mixins/ISummaryVue";
import { Roles } from "@timesheets/routes-app";
import { TBase } from "@timesheets/constants-common";
import Vue from "vue";
import { WebApplicationConstants } from "../../../setup/WebApplicationConstants";
import { getComponentRoleProp } from "../props/getComponentRoleProp";
import { getDynamicQueryOptionsProp } from "../props/getDynamicQueryOptionsProp";
import { getImpersonatingRoleProp } from "../props/getImpersonatingRoleProp";

/**
 *
 * @returns A mixing to handle which role a component should display for and, additionally, where it's actually impersonating that role from another role
 */
export function componentRoleTypeMixins() {
  return {
    props: {
      dynamicQueryOptions: getDynamicQueryOptionsProp(),
      componentRole: getComponentRoleProp(),
      impersonatingRole: getImpersonatingRoleProp(),
    },
    computed: {
      /**
       * The role used to select which role-name-prefixed-component to display (e.g. ContractingRoleClientDetail)
       * @param this A vue component that chooses sub components based on roles
       * @returns The type of role to display
       */
      componentRoleName(this: Vue & { componentRole?: TBase | string }): string | undefined {
        if (!this.currentRole) {
          return undefined;
        }

        if (!this.componentRole) {
          return this.currentRole.type;
        }

        const componentRoleName = typeof this.componentRole === "string" ? this.componentRole : this.componentRole.TypeName;

        return componentRoleName;
      },

      /**
       *
       * @param this Automatically prefixes the parent component with the component role class name
       * @returns
       */
      roleTypeCssName(this: Vue & { componentRoleName: string | undefined }) {
        const className = this.componentRoleName
          ? this.componentRoleName
              .split(/(?=[A-Z])/)
              .join("-")
              .toLowerCase()
          : "";

        return className;
      },
    },

    watch: {
      componentRoleName(this: ISummaryVue<ISummaryRowEntity, IFilter, IRowMeta, IResolvedPermissions>, newValue?: string, oldValue?: string) {
        if (!newValue && newValue !== oldValue && !this.$route.fullPath.startsWith(Roles.Root)) {
          this.$router.push(Roles.Root).catch((error: Error) => {
            WebApplicationConstants.defaultLogger.warn(`Navigating to roles root after missing current role failed (${Roles.Root})`);
            WebApplicationConstants.defaultLogger.error(new GemmaError(error));
          });
        }
      },
    },
  };
}
